import useAirUserRoles from "utils/AuthUtils";

/**
 * Only show the child components to users with the DEV role.
 *
 * Use-case: for extra admin and debugging utilities, that could be confusing or ugly for
 * normal users.
 */
export default function DevOnly({ children, style }) {
  const { isDeveloper } = useAirUserRoles();
  if (isDeveloper()) {
    return (
      <div className="DevOnly" style={style}>
        {children}
      </div>
    );
  }
  return null;
}
